import React from "react";
import { connect } from "react-redux";
import { FacilitySelectOtherType,  CreateUpdateSelected } from "../../services/facility/action";

 class Approval extends React.Component {
  constructor(props) {

    super(props)
    this.state = {
     
      data: [
        {
            "id": 1,
            "type": "Government entity",
            "isDefault": false
        },
        {
            "id": 2,
            "type": "Medical malpractice",
            "isDefault": false
        },
        {
            "id": 3,
            "type": "Other legal action",
            "isDefault": false
        },
        {
            "id": 4,
            "type": "Life insurance",
            "isDefault": false
        },
        {
            "id": 5,
            "type": "Disability claim",
            "isDefault": false
        },
        {
            "id": 6,
            "type": "HEDIS",
            "isDefault": false
        },
        {
          "id": 7,
          "type": "Request directly made by patient",
          "isDefault": false
      }
    ],
      list : [],
      access_token: "",
      facilityId: ""
 
    };
  }
 



  componentDidMount() {
    if (this.props.profileDetails) {
       let access_token = this.props.loginDetails;
       let facilityId = this.props.profileDetails.commonUser.userId
        this.setState({
          access_token,
          facilityId
        })

        this.props.FacilitySelectOtherType(access_token, facilityId )
    }
  }

  selectRecords = (e, item, key) => {
    let data = this.state.data;
    item.isDefault = !item.isDefault;
    data[key].isDefault = item.isDefault;

    let list = this.state.list;
    let obj = {
      "otherRequestorClassificationId": item.id
    }

    if( item.isDefault){
      list.push(obj);
    }
    if( !item.isDefault){
    
        list.filter((type)=>{
         if(type.otherRequestorClassificationId == item.id){       
            let index = list.indexOf(type);
            list.splice(index,1);
         }
          
        })
      
    }
    this.setState({
        data,
        list
    })
}
  
submitSelected = () =>{
  const { access_token, facilityId, list} = this.state;
    let payload = {
      facilityId,
      list
    }

  this.props.CreateUpdateSelected(access_token, payload)
}

   

  componentWillReceiveProps = nextProps => {
      if(nextProps.facilitySelectTypesStatus){
        let selectedList = nextProps.facilitySelectTypesDetails.facilityClassificationList;
        let fullList = this.state.data
        let list = []


          selectedList.map(item=>{
            let obj = {
              "otherRequestorClassificationId": item.id
            }
           list.push(obj)
          })
          
             fullList.map(first  =>{
            return selectedList.some(second=>{
                if(first.id == second.id){
                    first.isDefault = true
                }
             }) 
          })
      
        this.setState({
          data :fullList,
          list
        })
      } 
  };
  render() {
 
    return (
      <React.Fragment>
 
                      {/* Tab For Change Password */}
                      <div className="row tab-pane"    id="chang-pas">
                           <div className="col-lg-12 col-md-12 col-sm-12 co-xs-12">

                            <h4>
                            Please select which types of requests you would like to approve prior to processing
                                                    </h4>
                            <hr />

                          </div>

                           <div  className="col-md-6">
                                    <div>
                                        {this.state.data.length > 0 ?
                                            this.state.data.map((item, id) => {
                                                return (
                                                    <div key={id} className="form-group">
                                                        <input className="inp-cbx" id={item.type} data-name={id}
                                                            onChange={(e) => this.selectRecords(e, item, id)} checked={item.isDefault}
                                                            type="checkbox" style={{ display: "none" }} />
                                                        <label className="cbx" htmlFor={item.type}><span>
                                                            <svg width="12px" height="10px" viewBox="0 0 12 10"><polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg>
                                                        </span><span className="check-lab">{item.type}</span></label>
                                                    </div>
                                                )
                                            }) : <tr style={{ background: "transparent" }}><td colspan="6"><img alt="" src="images/no-record-found.png" width="130px" style={{ opacity: "0.2" }} /></td></tr>
                                        }

                                    </div>
                                    <div className="text-right">
                            <button type="button" onClick={this.submitSelected}  className="btnDefault">Submit 
                            </button> </div>
                                </div>

                      </div>

                    
      </React.Fragment>
    )
  }
}
const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,
  facilitySelectTypesDetails : state.facilityReducer.facilitySelectTypesDetails,
  facilitySelectTypesStatus : state.facilityReducer.facilitySelectTypesStatus
  
});

const mapDispatchToProps = dispatch => ({
  FacilitySelectOtherType: (token, facilityId) => dispatch(FacilitySelectOtherType(token, facilityId)),
  CreateUpdateSelected: (token, payload) => dispatch( CreateUpdateSelected(token, payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Approval);




 